export default __webpack_public_path__ + "e09cb8360aeee402ec888ced791720b1.png";